import React from "react";

import {TICKET_OUT_FIELDS,
} from "./constants";

import { TableCell} from "@material-ui/core";
import "./TicketOut.css"
import {Layout} from "../global/Table/TablePageHelpers/LayoutObject";
import TablePage from "../global/Table/TablePage";
import TwoStepDelete from "../global/subcomponents/twoStepDelete/TwoStepDelete";


class TicketOutTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deleteId: null,
        };
    }


    getTableHeaders = () => {
        let headers = []
        TICKET_OUT_FIELDS.forEach((headCell) => {
            headers.push(Layout.columnHead(headCell.label, headCell.id, headCell.align))
        })
        headers.push(Layout.columnHead(null,null))
        return headers
    }


    tableRow = (ticket) => {
        return (
            <React.Fragment>
                <TableCell></TableCell>
                <TableCell className="table-cell-left">{ticket?.machine}</TableCell>
                <TableCell className="table-cell-left">{ticket?.ticketOut} </TableCell>
                <TableCell className="table-cell-left">{ticket?.time}</TableCell>
                <TableCell className="center">
                    {ticket?.photoPath ? (
                        <span
                            role="button"
                            tabIndex={0}
                            style={{ color: '#2563eb', cursor: 'pointer', fontWeight: 600 }}
                            onClick={() => this.props.onViewPhoto && this.props.onViewPhoto(ticket)}
                        >
                            View
                        </span>
                    ) : (
                        <span style={{ color: '#cbd5e1' }}>—</span>
                    )}
                </TableCell>
                <TableCell className="table-cell-left"></TableCell>

                <TwoStepDelete
                    rowId={ticket?.ticketId}
                    handleDelete={(rowIdToDelete) => this.props.deleteTicketOut({ticketId: ticket?.ticketId})}
                    deleteId={this.state.deleteId}
                    setDeleteId={(newDeleteId) => this.setState({deleteId: newDeleteId})}
                />

            </React.Fragment>
        )
    }


    render() {

        const ticketData = this.props.ticketOut || [];
       // const uniqueMachines = new Set(ticketData.map(item => item.machine)).size;
        const totalTickets = ticketData.length;
        const totalTicketOut = ticketData.reduce((sum, item) => sum + parseFloat(item.ticketOut), 0);

        return (
            <>

                                <div
                                    style={{
                                        backgroundColor: this.props.userInfo?.employeeColor ? this.props.userInfo?.employeeColor :"#011217",
                                        color: "white",
                                        padding: "16px",
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        marginTop: "16px",
                                    }}
                                >
                                    Tickets ({totalTickets}), Total ({totalTicketOut})
                                </div>

                                <TablePage
                                    tableName="ticketOut"
                                    tableRows={this.props.ticketOut}
                                    tableColumnHeads={this.getTableHeaders()}
                                    tableRow={this.tableRow}
                                    paginationText="Results"
                                    defaultSortBy="machine"
                                />



            </>

        )
    }
}


export default TicketOutTable;



